var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopWatchGeolocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 11.3238L8.82899 8.49579C9.38834 7.93635 9.76923 7.22362 9.92352 6.44771C10.0778 5.67181 9.99855 4.86758 9.69578 4.13671C9.39301 3.40585 8.88032 2.78117 8.22254 2.34168C7.56476 1.90218 6.79142 1.6676 6.00033 1.6676C5.20923 1.6676 4.4359 1.90218 3.77812 2.34168C3.12034 2.78117 2.60765 3.40585 2.30487 4.13671C2.0021 4.86758 1.92285 5.67181 2.07714 6.44771C2.23142 7.22362 2.61232 7.93635 3.17166 8.49579L6.00033 11.3238ZM9.77166 9.43846L6.00033 13.2098L2.22899 9.43846C1.48314 8.69257 0.975219 7.74226 0.769453 6.7077C0.563687 5.67314 0.669321 4.6008 1.073 3.62628C1.47667 2.65175 2.16026 1.81882 3.03732 1.23279C3.91437 0.646772 4.94551 0.333984 6.00033 0.333984C7.05515 0.333984 8.08628 0.646772 8.96334 1.23279C9.8404 1.81882 10.524 2.65175 10.9277 3.62628C11.3313 4.6008 11.437 5.67314 11.2312 6.7077C11.0254 7.74226 10.5175 8.69257 9.77166 9.43846ZM1.33366 13.6671H10.667V15.0005H1.33366V13.6671Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopWatchGeolocation);
export default __webpack_public_path__ + "static/media/stopWatchGeolocation.90a82a3bc88b221f084f7027c45a18b9.svg";
export { ForwardRef as ReactComponent };